export default {"src":"/_next/static/media/search-icon-blue.2de58cbd.gif","height":13,"width":13,"blurWidth":0,"blurHeight":0};